const getInitialValues = (materialFocusedPlant, mrpFocusedPlant) => ({
  mrp_type: 'V1', // mrpFocusedPlant?.MRPType ? `${mrpFocusedPlant?.MRPType}` : '', // Currently restricting it to V1
  lead_time: materialFocusedPlant?.CC_LEAD_TIME ? `${materialFocusedPlant?.CC_LEAD_TIME}` : '',
  max_criticality: materialFocusedPlant?.CC_MAX_CRITICALITY ? `${materialFocusedPlant?.CC_MAX_CRITICALITY}` : 'None',
  approved_deviation: mrpFocusedPlant?.ABCIndicator === 'A',
});

export default getInitialValues;
